import * as React from "react";
const SvgPrinter = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.625 1.871v4.975h1.498V3.379h9.754v3.467h1.498V1.87H12ZM1.871 8.437v10.877h3.754V22.127h12.75V19.314h3.754V8.437H12ZM3.38 9.937H20.62v7.873h-2.246v-2.815H5.625v2.815H3.379V13.87zm3.744 6.566h9.754v4.119H7.123v-2.06z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgPrinter;
